import { ref } from 'vue'
import { useGamesStore } from '@nsftx/seven-client-retail-vue-sgp'

interface LastVisitedGame {
  id: string
  name: string
}

const LAST_VISITED_GAME_SESSION_KEY = 'pos_last_visited_game'

const getSessionLastVisitedGame = () => {
  const sessionLastVisitedGame = sessionStorage.getItem(LAST_VISITED_GAME_SESSION_KEY)

  if (!sessionLastVisitedGame) {
    return null
  }

  try {
    return JSON.parse(sessionLastVisitedGame) as LastVisitedGame
  } catch {
    return null
  }
}

export const useLastVisitedGame = () => {
  const { linkGames: games } = useGamesStore()

  const getDefaultLastVisitedGame = (): LastVisitedGame | null =>
    games.length ? { id: games[0].displayId, name: games[0].name } : null

  const lastVisitedGame = ref<LastVisitedGame | null>(
    getSessionLastVisitedGame() ?? getDefaultLastVisitedGame(),
  )

  const setLastVisitedGame = (gameId: string, gameTitle: string) => {
    const game = { id: gameId, name: gameTitle }

    lastVisitedGame.value = game
    sessionStorage.setItem(LAST_VISITED_GAME_SESSION_KEY, JSON.stringify(game))
  }

  return {
    lastVisitedGame,
    setLastVisitedGame,
  }
}
